import {
  Box,
  Text,
  Avatar,
  ActionIcon,
  Menu,
  Drawer,
  Flex,
  Stack,
  Image,
} from "@mantine/core";
import {
  IconLogout,
  IconCamera,
  IconPencil,
  IconClock,
} from "@tabler/icons-react";
import ModalSetting from "components/modal/modalSetting/ModalSetting";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useAuthentication from "stores/AuthenticationStore/authentication";
import notiLogout from "assets/images/pngs/noti-logout.png";
import { GetUserProfile } from "@/dto/auth/response/auth-response";
import { useDisclosure, useLocalStorage } from "@mantine/hooks";
import UIDefault from "assets/images/pngs/ui-default.png";
import UIOld from "assets/images/pngs/ui-old.png";

interface UserDropdownProps {
  userInfo: GetUserProfile;
}

const UserDropdown: React.FC<UserDropdownProps> = ({ userInfo }) => {
  const { t } = useTranslation();
  const [stateAuth, actionAuth] = useAuthentication();
  const [openLogout, setOpenLogout] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [ui, setUi] = useLocalStorage({ key: "theme", defaultValue: "default" });
  return (
    <>
      <Menu.Dropdown>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "24px 0",
            gap: "16px",
            borderRadius: "8px",
          }}
        >
          {/* Thông tin người dùng */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
              borderBottom: "1px solid #F0F2F7",
              paddingBottom: "8px",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: 56,
                height: 56,
              }}
            >
              <Avatar src={userInfo.userAvatar} size={56} radius="xl" />
              <ActionIcon
                size={20}
                radius="xl"
                variant="filled"
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  transform: "translate(25%, 25%)",
                  border: "2px solid white",
                  backgroundColor: "#2A81D0",
                  pointerEvents: "none",
                }}
              >
                <IconCamera size={12} stroke={1.5} color="white" />
              </ActionIcon>
            </Box>

            <Box>
              <Text align="center" weight={600} size="xl">
                {userInfo.fullName}
              </Text>
              <Text align="center" color="dimmed" size="md">
                {userInfo.userRole}
              </Text>
            </Box>
          </Box>

          {/* Các tùy chọn menu */}
          <Box
            sx={{
              color: "#2A81D0",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              fontWeight: 700,
            }}
          >
            <MenuItem
              icon={<IconPencil size={24} stroke={1.5} />}
              text={t("EDIT_INFORMATION")}
            />
            <MenuItem
              icon={<IconClock size={24} stroke={1.5} />}
              text={t("LOGIN_HISTORY")}
            />
            <MenuItem
              onClick={open}
              icon={<IconClock size={24} stroke={1.5} />}
              text={t("APPEARANCE")}
            />
            <MenuItem
              onClick={() => {
                // actionAuth.logout();
                setOpenLogout(true);
              }}
              icon={<IconLogout size={24} stroke={1.5} />}
              text={t("LOGOUT")}
            />
          </Box>
          <ModalSetting
            opened={openLogout}
            close={() => setOpenLogout(false)}
            img={notiLogout}
            title={t<string>("DO_YOU_WANT_TO_LOG_OUT?")}
            btn={2}
          />
        </Box>
      </Menu.Dropdown>
      <Drawer
        opened={opened}
        onClose={close}
        title={t("TUY_CHINH_GIAO_DIEN")}
        overlayProps={{ opacity: 0.5, blur: 4 }}
      >
        {/* Drawer content */}
        <Flex gap={20} p={20}>
          <Stack spacing={8} align="center" w="50%">
            <Box
              onClick={() => {
                setUi("default");
                close();
              }}
              style={{
                cursor: "pointer",
                borderRadius: 12,
                border: ui === "default" ? "2px solid #2A81D0" : "2px solid transparent",
              }}
            >
              <Image radius={12} src={UIDefault} width={180} height={150} />
            </Box>
            <Text weight={ui === "default" ? 700 : 400} color={ui === "default" ? "#2A81D0" : undefined}>
              {t("DEFAULT_BADGE")}
            </Text>
          </Stack>
          <Stack spacing={8} align="center" w="50%">
            <Box
              onClick={() => {
                setUi("old");
                close();
              }}
              style={{
                cursor: "pointer",
                borderRadius: 12,
                border: ui === "old" ? "2px solid #2A81D0" : "2px solid transparent",
              }}
            >
              <Image radius={12} src={UIOld} width={180} height={150} />
            </Box>
            <Text weight={ui === "old" ? 700 : 400} color={ui === "old" ? "#2A81D0" : undefined}>
              {t("OLD_INTERFACE")}
            </Text>
          </Stack>
        </Flex>
      </Drawer>
    </>
  );
};

interface MenuItemProps {
  icon: React.ReactNode;
  text: string;
  onClick?: any;
}

const MenuItem: React.FC<MenuItemProps> = ({ icon, text, onClick }) => (
  <Box
    sx={{
      display: "flex",
      padding: "10px 24px",
      gap: "8px",
      cursor: "pointer",
      alignItems: "center",
    }}
    onClick={onClick}
  >
    {icon}
    <Text sx={{ fontSize: "14px" }}>{text}</Text>
  </Box>
);

export default UserDropdown;
